import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  private readonly cookieName = 'cookiesConsent';

  isConsentExpired(): boolean {
    const cookieValue = this.getCookie(this.cookieName);
    if (!cookieValue) return true;

    try {
      const data = JSON.parse(decodeURIComponent(cookieValue));
      const acceptedDate = new Date(data.date);
      const now = new Date();
      const expiryDate = new Date(acceptedDate);
      expiryDate.setMonth(acceptedDate.getMonth() + 12);

      return now > expiryDate;
    } catch {
      return true;
    }
  }

  hasConsent(): boolean {
    const cookieValue = this.getCookie(this.cookieName);
    if (!cookieValue) return false;

    try {
      const data = JSON.parse(decodeURIComponent(cookieValue));
      return data.accepted === true && !this.isConsentExpired();
    } catch {
      return false;
    }
  }

  saveConsent(): void {
    const data = {
      accepted: true,
      date: new Date().toISOString(),
    };
    const expires = new Date();
    expires.setMonth(expires.getMonth() + 12);

    document.cookie = `${this.cookieName}=${encodeURIComponent(
      JSON.stringify(data)
    )}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  }

  private getCookie(name: string): string | null {
    const cookies = document.cookie.split(';');
    const match = cookies.find((c) => c.trim().startsWith(`${name}=`));
    return match ? match.trim().substring(name.length + 1) : null;
  }
}
